import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import { Outlet } from 'react-router-dom';
import MessagingContacts from './components/MessagingContacts';
import NewMessageModal from './components/modals/NewMessageModal';
import MessagingContext from './providers/Messaging/Messaging.context';
import ContactPreview from 'router/subrouters/Dash/subrouters/private/subrouters/Messaging/components/ContactPreview';
import { MainLayoutContext } from 'router/subrouters/Dash/Dash.router';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';

import './Messaging.styles.scss';
import './Messaging.styles.responsive.scss';

type MessagingRouterProps = {
  className?: string;
};

const MessagingRouter: React.FC<MessagingRouterProps> = ({ className }) => {
  const { addMainClassName, resetMainClassName } =
    useContext(MainLayoutContext);
  const { contactOpen, currentSession, contactsOpen } =
    useContext(MessagingContext);

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  const classes = classNames(className, 'messaging-router');

  useEffect(() => {
    addMainClassName('dash-messaging');

    return () => {
      resetMainClassName();
    };
  }, [addMainClassName, resetMainClassName]);

  return (
    <div className={classes}>
      <NewMessageModal ref={modalRef} />

      <MessagingContacts
        className={classNames('messaging-router__contacts', {
          'messaging-router__contacts--open': contactsOpen,
          'messaging-router__contacts--empty-sessions': !currentSession,
        })}
        onNewMessage={modal?.open}
      />

      <div
        className={classNames('messaging-router__chat', {
          'messaging-router__chat--open': !contactsOpen && !contactOpen,
        })}
      >
        <Outlet />
      </div>

      <ContactPreview
        className={classNames('messaging-router__contact', {
          'messaging-router__contact--open': contactOpen,
        })}
      />
    </div>
  );
};

export default MessagingRouter;
